import i18n from "../../../i18n";

import {
  AUTOCOMPLETE_FIELD_TYPE,
  BOOLEAN_FIELD_TYPE,
  DATETIME_TO_DATE_RANGE_FIELD_TYPE,
  NUMERIC_RANGE_FIELD_TYPE,
  TEXT_FIELD_TYPE,
} from "../../../helpers/constants";

import SelectFieldService from "../../../services/selectFieldService";

import DateService from "../../../services/dateService";

import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import { IconButton } from "@mui/material";

import {
  convertFlatListFromBackendToTranslatedOptionObject,
  convertObjectListFromBackendToTranslatedOptionObject,
} from "../../../helpers/methods";

import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";

import AlertMarker from "../../other/AlertMarker/AlertMarker";

export const EQUIPMENT_BMS_TABLE_NAME = "equipment_bms";

export const EQUIPMENT_BMS_TABLE_CONFIG = [
  {
    name: "equipment_bms_alert",
    getValueCallback: (rowData) => (
      <div style={{ display: "flex" }}>
        {rowData.equipment_bms_alert.map((equipmentBmsAlert) => (
          <AlertMarker
            alertIcon={equipmentBmsAlert.alert?.alert_icon}
            alertBody={equipmentBmsAlert.equipment_bms_alert_body}
          />
        ))}
      </div>
    ),
    label: i18n.t("table.counter_repository.equipment_bms_alert"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: convertObjectListFromBackendToTranslatedOptionObject(
        filteringData.value.equipment_bms_alert,
        "alert_type"
      ),
      isObjectOption: true,
      optionLabelKey: "alert_type",
      addNewValue: false,
      multiple: true,
      style: { minWidth: "100px" },
    }),
  },
  {
    name: "equipment",
    getValueCallback: (rowData) => rowData.equipment_nr,
    label: i18n.t("table.counter_repository.equipment"),
    filterType: null,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData.value.equipment,
      isObjectOption: true,
      optionLabelKey: "equipment_nr",
      addNewValue: false,
      multiple: true,
    }),
    other_export_field_name: "equipment_nr",
    sortable: true,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipbms_date",
    getValueCallback: (rowData) =>
      DateService.convertDatetimeFromBackendToFormatYYYYMMDD_hhmm(
        rowData.equipbms_date
      ),
    label: i18n.t("table.counter_repository.equipbms_date"),
    filterType: DATETIME_TO_DATE_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { minWidth: "100px" },
    }),
    sortable: true,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipbms_value",
    getValueCallback: (rowData) => rowData.equipbms_value,
    label: i18n.t("table.counter_repository.equipbms_value"),
    filterType: NUMERIC_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { minWidth: "100px" },
    }),
    sortable: true,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipbms_unit",
    getValueCallback: (rowData) => rowData.equipbms_unit,
    label: i18n.t("table.counter_repository.equipbms_unit"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipbms_manual",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(rowData.equipbms_manual),
    label: i18n.t("table.counter_repository.equipbms_manual"),
    filterType: BOOLEAN_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipbms_status",
    getValueCallback: (rowData) =>
      i18n.t(`backend_choices_list.${rowData.equipbms_status}`),
    label: i18n.t("table.counter_repository.equipbms_status"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: convertFlatListFromBackendToTranslatedOptionObject(
        filteringData.value.equipbms_status
      ),
      isObjectOption: true,
      multiple: true,
    }),
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "equipbms_note",
    getValueCallback: (rowData) => rowData.equipbms_note,
    label: i18n.t("table.counter_repository.equipbms_note"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "bms_is_in_settlement",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(
        rowData.bms_is_in_settlement
      ),
    label: i18n.t("table.counter_repository.bms_is_in_settlement"),
    filterType: BOOLEAN_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "bms_is_start_settlement",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(
        rowData.bms_is_start_settlement
      ),
    label: i18n.t("table.counter_repository.bms_is_start_settlement"),
    filterType: BOOLEAN_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "bms_is_end_settlement",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(
        rowData.bms_is_end_settlement
      ),
    label: i18n.t("table.counter_repository.bms_is_end_settlement"),
    filterType: BOOLEAN_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    headerSx: { whiteSpace: "break-spaces" },
  },
  {
    name: "preview",
    getValueCallback: (rowData, onPreview) =>
      rowData.enclosure?.content_type === "application/pdf" ||
      (rowData.enclosure?.content_type &&
        rowData.enclosure?.content_type.includes("image")) ? (
        <IconButton
          color="primary"
          onClick={() => {
            onPreview(rowData.enclosure.id);
          }}
          sx={{ padding: "5px" }}
        >
          <PreviewOutlinedIcon fontSize="medium" />
        </IconButton>
      ) : null,
    label: i18n.t("table.enclosure.preview"),
    filterType: null,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { maxWidth: "100px" },
    }),
  },
  {
    name: "edit",
    label: i18n.t("edit"),
    getValueCallback: (rowData, onPreview, onClickEdit) => {
      const content = (
        <ModeEditOutlineOutlined onClick={() => onClickEdit(rowData.id)} />
      );
      return rowData.is_allowed_to_edit ? content : "";
    },
    filterType: null,
  },
];
